import React from "react";
import {
  DropdownMenu,
  DropdownMenuPortal,
  DropdownMenuTrigger,
} from "@/components/ui/DropdownMenu";
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/Card";

import { ChartActionsButton } from "@/components/ChartActionsButton";
import { ChartOptionsMenuItem } from "@/components/ChartOptionsMenuItem";
import { RiseStar } from "@/assets/svg/RiseStar";

export interface ChartHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  menuOptions?: {
    label: string;
    onClick?: () => void;
    icon?: React.ReactNode;
  }[];
  showRiseIcon?: boolean;
  disabled?: boolean; // New prop to disable the actions button
}

export const ChartHeader: React.FC<ChartHeaderProps> = ({
  title,
  subtitle,
  menuOptions,
  disabled,
  showRiseIcon,
}) => {
  return (
    <CardHeader className="flex flex-row items-start justify-between pb-4">
      <div className="flex w-full items-start justify-between">
        <div className="flex flex-col gap-2">
          <div className="flex gap-2">
            {showRiseIcon && <RiseStar />}
            <CardTitle className="text-[16px] leading-none font-semibold tracking-tight">
              {title}
            </CardTitle>
          </div>
          {subtitle && <CardDescription>{subtitle}</CardDescription>}
        </div>
        <div className="flex items-center gap-2">
          <DropdownMenu>
            <DropdownMenuTrigger
              asChild
              disabled={disabled || !menuOptions?.length}
              data-testid="engagement-dropdown-menu-trigger"
            >
              <ChartActionsButton disabled={disabled || !menuOptions?.length} />
            </DropdownMenuTrigger>
            <DropdownMenuPortal>
              <ChartOptionsMenuItem {...{ menuOptions }} />
            </DropdownMenuPortal>
          </DropdownMenu>
        </div>
      </div>
    </CardHeader>
  );
};
